
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perennial-mandalism",
      function () {
        return require("private-next-pages/perennial-mandalism/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perennial-mandalism"])
      });
    }
  